import React from 'react';

import { Box, Divider, Paper, Typography } from '@mui/material';
import { mobileBreakpoint, useIsMobile, useL10n } from '@uplift/hooks';
import { Button } from '@uplift/ui-v2';

import { useSettingsStyles } from '../../../settings/styles';
import { useBillingContext } from './billing.context';
import {
  AddPaymentMethod, AutopayModule, ContactSupport,
  MobileOnly, PaymentMethodView,
} from './components';


export const BillingSettingsPaymentMethodSection: React.VFC = () => {
  const isMobile = useIsMobile(mobileBreakpoint);
  const l10n = useL10n();
  const { classes: settingsClasses } = useSettingsStyles();
  const {
    isAutopayOn,
    isMedicaid,
    balance,
    cardExpiredOrDeclined,
    isCardMissing,
    handleEditPaymentMethod,
    isBillingMissing,
    showPayBalanceStickyButton,
    showEditPaymentMethodButton,
    toggleAutopayUpdate,
    handlePayBalanceClick,

  } = useBillingContext();

  return (
    <>
      <Box px={isMobile ? 2 : 0} pt={4} pb={2} display="flex" >
        <Typography variant="h4">{l10n.accountSettings.billing.paymentMethod}</Typography>
      </Box>
      {isMobile && <Divider className={settingsClasses.divider} />}
      <Box display="flex" flexDirection="column" alignSelf="stretch">
        <Paper elevation={isMobile ? 0 : 4} square={isMobile}>
          <Box display="flex" flexDirection="column" hidden={isBillingMissing}>
            {isCardMissing
              ? (<AddPaymentMethod onClick={handleEditPaymentMethod} />)
              : (<PaymentMethodView onClick={handleEditPaymentMethod} />)}
          </Box>
          <Divider />
          {!isCardMissing && !isMedicaid && <AutopayModule isMobile={isMobile} isAutopayOn={isAutopayOn} onClick={toggleAutopayUpdate} />}
        </Paper>
      </Box>

      {isMobile && <Divider className={settingsClasses.divider}/>}
      <ContactSupport isMobile={isMobile} />

      <MobileOnly show={showPayBalanceStickyButton || showEditPaymentMethodButton}>
        <Box className={settingsClasses.fixedContainer}>
          {showPayBalanceStickyButton && (
            <Button variant="contained" color="secondary" fullWidth onClick={handlePayBalanceClick}>
              {cardExpiredOrDeclined ? l10n.accountSettings.billing.editAndPay : l10n.accountSettings.billing.payBalance}
            </Button>
          )}
          {showEditPaymentMethodButton && (
            <Button
              variant={!balance ? 'contained' : 'outlined'}
              color="secondary"
              fullWidth
              onClick={handleEditPaymentMethod}
            >
              {isCardMissing ? l10n.accountSettings.billing.addPaymentMethod : l10n.accountSettings.billing.editPaymentMethod}
            </Button>
          )}
        </Box>
      </MobileOnly>
    </>
  );
};
